import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckBoxComponent),
      multi: true,
    },
  ],
})
export class CheckBoxComponent implements ControlValueAccessor {
  @Input() checkBoxControl?: FormControl<boolean> | AbstractControl<any, any>;
  @Input() isDisabled = false;
  @Input() dataCy: string;

  @Input()
  set checked(value: boolean) {
    this.state = !!value;
  }

  @Output() checkedChange = new EventEmitter<boolean>();

  protected state = false;

  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  protected get isChecked(): boolean {
    return this.checkBoxControl ? !!this.checkBoxControl.value : this.state;
  }

  protected onToggle(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;

    if (this.checkBoxControl) {
      this.checkBoxControl.setValue(checked, { emitEvent: false });
      this.checkBoxControl.markAsDirty();
      this.checkBoxControl.updateValueAndValidity();
    } else {
      this.state = checked;
      this.onChange(checked);
    }

    this.onTouched();
    this.checkedChange.emit(checked);
  }

  writeValue(value: boolean): void {
    this.state = !!value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
